angular.module('ApptBookApp').directive('appointmentbookpager', function () {
    return {
        restrict: "E",
        replace: true,
        transclude: true,
        templateUrl: "app/plugins/AppointmentBook/views/directives/appointmentbookpager.html",
        link: (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            scope.firstPage = () => {
                if (scope.globals.currentPage == 1 || scope.globals.disableDateChange) {
                    return;
                }
                scope.globals.currentPage = 1;
                scope.builder.gotoCurrentPage();
            }
            scope.lastPage = () => {
                if (scope.globals.currentPage == scope.globals.totalPages || scope.globals.disableDateChange) {
                    return;
                }
                scope.globals.currentPage = scope.globals.totalPages;
                scope.builder.gotoCurrentPage();
            }
            scope.nextPage = () => {
                if (scope.globals.currentPage == scope.globals.totalPages || scope.globals.disableDateChange) {
                    return;
                }
                scope.globals.currentPage++;
                scope.builder.gotoCurrentPage();
            }
            scope.previousPage = ()=>
            {
                if (scope.globals.currentPage == 1 || scope.globals.disableDateChange) {
                    return;
                }
                scope.globals.currentPage--;
                scope.builder.gotoCurrentPage();
            }
            scope.loadPage = (i) => {
                if (scope.globals.currentPage == i || scope.globals.disableDateChange) {
                    return;
                }
                scope.globals.currentPage = i;
                scope.builder.gotoCurrentPage();                
            }
        }
    }
});